import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingCropTillagesByPrimaryDataId, setFootprintingCropTillagesByPrimaryDataIdAdmin } from "services";

import { footprintingCropPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_CROP_TILLAGES } from "consts";

import { FootprintingCropTillage } from "models";

export const useMutateFootprintingCropTillages = (
  farmId: string,
  cropId: string,
  year: number,
  payload: Array<FootprintingCropTillage>,
  primaryDataId: string
) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? setFootprintingCropTillagesByPrimaryDataIdAdmin : setFootprintingCropTillagesByPrimaryDataId;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_CROP_TILLAGES, primaryDataId, isAdmin],
      mutationFn: () => queryFn(payload, primaryDataId),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_CROP_TILLAGES, primaryDataId, isAdmin],
          ...footprintingCropPrimaryQueryKeys(primaryDataId, farmId, cropId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
